<template>
    <div class="profile-wrapper">
        <div class="text-xs-center">
            <v-menu
                v-model="dialog"
                offset-y
                :close-on-content-click="false"
                class="profile-display"
            >
                <template v-slot:activator="{ on }">
                    <v-btn class="profile__icon-color" color="lighten-2" dark v-on="on">
                        <div class="profile__icon-wrapper">
                            <icon class="user-profile" icon="user-circle" :height="25" :width="25"></icon>
                        </div>
                    </v-btn>
                </template>

                <v-card class="profile">
                    <div class="profile__wrapper">
                        <div class="profile__user-wrapper">
                            <div class="profile-name">
                                {{ $t('header.signed_as') }}
                            </div>
                            <div class="user-name">{{ getGivenName }}</div>
                        </div>
                        <div class="settings">
                            <router-link :to="{ name: 'profile' }">
                                <div class="profile__link"> <icon class="settings-icon" icon="user-profile" color="#6e6e6e" :height="22" :width="19" /> <span class="profile__link-text">Profile</span></div>
                            </router-link>
                        </div>
                        <organization-impersonate @handleImpersonatedOrg="handleImpersonatedOrg" class="profile__organization"></organization-impersonate>
                        <logout class="profile__logout"></logout>
                    </div>
                </v-card>
            </v-menu>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from '@/components/atoms/Icon'
import OrganizationImpersonate from '@/components/layout/header/OrganizationImpersonate'
import Logout from '@/components/layout/header/Logout'

export default {
    name: 'Profile',
    components: {
        Icon,
        OrganizationImpersonate,
        Logout
    },
    data () {
        return {
            dialog: false
        }
    },
    computed: {
        ...mapGetters('authModule', [
            'getGivenName'
        ])
    },
    methods: {
        handleImpersonatedOrg (currentOrgName) {
            this.$emit('handleImpersonatedOrg', currentOrgName)
        }
    }
}
</script>

<style scoped lang="scss">
.profile-wrapper {
    margin-right: 23px;
    margin-left: 13px;
    transition: opacity 0.3s;

    @include breakpoint(md) {
        margin-left: 23px;
        margin-right: 10px;
    }

    @media (min-width: 962px) {
        margin-left: 33px;
    }

    &:hover {
        opacity: 0.5;
    }
    ::v-deep .v-autocomplete__content.v-menu__content {
        z-index: 999 !important;
    }

    .v-overlay--active:before {
        opacity: 0 !important;
    }
}

.profile {
    display: flex;
    align-items: center;
    position: relative;
    width: 240px;
    &__wrapper {
        display: flex;
        flex-direction: column;
    }

    &__btn {
        background-color: transparent !important;
        box-shadow: none !important;
        height: max-content !important;
        border-radius: 50%;
    }

    &__icon-color {
        background-color: transparent !important;
        box-shadow: none !important;
        padding: 0 5px;
    }

    &__icon-wrapper {
        display: inline-flex;
        padding: 10px;
        justify-content: center;
        align-items: center;
    }

    &__user-wrapper {
        padding: 10px 15px;
        border-bottom: 2px solid #eeeeee;
    }

    .profile-name {
        font-size: 12px;
        color: #6e6e6e;
    }

    .user-name {
        font-size: 12px;
        font-weight: 700;
        color: $dark;
    }

    .settings {
        padding: 15px;
        border-bottom: 2px solid #eeeeee;
    }

    &__link {
        color: #6e6e6e;
        display: flex;
        align-items: center;
        text-decoration: none;
        transition: opacity 0.3s;

        &:hover {
            opacity: 0.5;
            text-decoration: none;
        }
    }

    a:hover:not(.no-underline):not(.v-list__tile) {
        text-decoration: none;
    }

    &__link-text {
        margin-left: 10px;
        text-decoration: none;
    }

    &__organization {
        padding: 5px 15px 10px;
        border-bottom: 2px solid #eeeeee;
    }

    &__logout {
        padding: 20px 15px;
        border-bottom: 2px solid #eeeeee;
    }
}
.settings-icon, .user-profile {
    color: $font
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
